import { FormattedMessage } from 'react-intl';
import TabularPage from '../components/tabs/TabularPage';
import { HYDRO_PROJECT_ROUTES } from 'constants/routes';

const routes = [
    {
        name: <FormattedMessage id="plant_configuration" />,
        relativePath: HYDRO_PROJECT_ROUTES.PLANT_CONFIG,
    },
    {
        name: <FormattedMessage id="plant_data" />,
        relativePath: HYDRO_PROJECT_ROUTES.PLANT_DATA,
    },
    {
        name: <FormattedMessage id="project_constraints" />,
        relativePath: HYDRO_PROJECT_ROUTES.PROJECT_CONSTRAINTS,
    },
    {
        name: <FormattedMessage id="elevation_capacity" />,
        relativePath: HYDRO_PROJECT_ROUTES.ELEVATION_CAPACITY,
    },
    {
        name: <FormattedMessage id="unit_ratings_and_data" />,
        relativePath: HYDRO_PROJECT_ROUTES.UNIT_RATINGS_AND_DATA,
    },
    {
        name: <FormattedMessage id="unit_outages" />,
        relativePath: HYDRO_PROJECT_ROUTES.UNIT_OUTAGES,
    },
];

const HydroProject = () => {
    return <TabularPage routes={routes} />;
};

export default HydroProject;
